<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-checkbox-view
      @change="updateValue"
      @other-change-text="updateOtherText"
      @other-change-box="updateOtherBox"
      :checkbox="saveData"
      :valid="valid"
      :validate="validate"
      :nid="nid"
    />
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Checkbox'"
      @setting-click="showSettings"
      @collapse-click="collapsePreview"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <fb-checkbox-view :checkbox="saveData"/>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <fb-checkbox-option
          @save-option="saveOptions('options', $event)"
          @save="save"
          :options="tempData.options"
        />
        <md-checkbox v-model="tempData.other">Other Field</md-checkbox>
        <div v-if="tempData.other">
          <md-field>
            <label>Other Label</label>
            <md-input v-model="tempData.other_label"></md-input>
          </md-field>
        </div>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbCheckboxOption from "./FbCheckboxOption";
import FbCheckboxView from "./FbCheckboxView";

export default {
  name: "FbCheckbox",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      let val = window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ].value;

      if(val.options && val.options.length) {
        this.saveData.options = val.options;
        this.saveData.value = this.saveData.options;
        this.saveData.other_value = val.other;
        this.saveData.other_text = val.other_text;
      }
      if (val && val.length){
        this.saveData.options = val;
        this.saveData.value = this.saveData.options;
      }
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      if (this.saveData.required === true && !this.saveData.value) {
        val = false;
      } else if (this.saveData.required === true && this.saveData.value) {
        let checked = this.saveData.value.filter(el => {
          return el.checked;
        });
        val = checked.length != 0;
        if(this.saveData.other_value && this.saveData.other_text != '') {
          val = true;
        }
      }
      // else if (this.saveData.required === true && !this.saveData.value.options || this.saveData.required === true && this.saveData.value.other_text == "") {
      //   return false;
      // }
      else {
        val = true;
      }
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: {
            options: this.saveData.value,
            other: this.saveData.other_value,
            other_text: this.saveData.other_text
          },
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  data() {
    return {
      showDialog: false,
      tempData: {
        other: this.element.data.other || false,
        other_value: this.element.data.other_value || false,
        other_text: this.element.data.other_text || "",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        help_text: this.element.data.help_text || "",
        other_label: this.element.data.other_label || "Enter other",
        required: this.element.data.required || false,
        value: []
      },
      saveData: {
        other: this.element.data.other || false,
        other_text: this.element.data.other_text || "",
        other_value: this.element.data.other_value || false,
        other_label: this.element.data.other_label || "Enter other",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        required: this.element.data.required || false,
        help_text: this.element.data.help_text || "",
        value: []
      }
    };
  },
  components: {
    FbCheckboxOption,
    FbCheckboxView
  },
  methods: {
    saveOptions: function saveOptions(type, data) {
      this.tempData[type] = data;
    },
    updateValue(value) {
      this.saveData.value = value;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    updateOtherBox(val) {
      this.saveData.other_value = val;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    updateOtherText(val) {
      this.saveData.other_text = val;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
  }
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
